import React, { forwardRef, type ReactNode } from "react";

import { renderIcon, type IconProp } from "src/shared/renderIcon";
import {
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "src/primitives/DropdownMenu";

interface SubMenuProps {
  label?: string;
  icon?: IconProp;
  children?: ReactNode;
  className?: string;
  triggerProps?: Omit<
    React.ComponentProps<typeof DropdownMenuSubTrigger>,
    "ref" | "className" | "children"
  >;
  contentProps?: Omit<
    React.ComponentProps<typeof DropdownMenuSubContent>,
    "children"
  >;
}

const SubMenu = forwardRef<HTMLDivElement, SubMenuProps>(
  ({ label, icon, children, className, triggerProps, contentProps }, ref) => (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger ref={ref} className={className} {...triggerProps}>
        {icon && <span className="shrink-0">{renderIcon(icon, "size-4")}</span>}
        {label && <span>{label}</span>}
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent {...contentProps}>
        {children}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
);
SubMenu.displayName = "Dropdown.SubMenu";

export { SubMenu };
